module.exports = __webpack_public_path__ + "img/HAB_COVER.d09be38f.png";